var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBlock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 10a10 10 0 1 0-10 10 10 10 0 0 0 10-10M10 2a8 8 0 0 1 8 8 7.9 7.9 0 0 1-1.69 4.9L5.1 3.69A7.9 7.9 0 0 1 10 2m-8 8a7.9 7.9 0 0 1 1.69-4.9L14.9 16.31A7.9 7.9 0 0 1 10 18a8 8 0 0 1-8-8"
})));
export default SvgIconBlock;